import React, { useState, useEffect } from 'react';
import { 
  HiOutlineUsers, 
  HiOutlineChatBubbleLeftRight, 
  HiOutlineBookOpen, 
  HiOutlineBell,
  HiOutlineArrowTrendingUp
} from 'react-icons/hi2';

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [greeting, setGreeting] = useState('');

  useEffect(() => {
    // Get user from localStorage
    const storedUser = JSON.parse(localStorage.getItem('user'));
    setUser(storedUser);

    // Set greeting based on time of day
    const hour = new Date().getHours();
    if (hour < 12) setGreeting('Good Morning');
    else if (hour < 17) setGreeting('Good Afternoon');
    else setGreeting('Good Evening');
  }, []);

  const stats = [
    { 
      label: 'Active Users', 
      value: '1,284', 
      change: '+12%', 
      icon: HiOutlineUsers, 
      color: 'bg-blue-50 text-blue-600',
      trend: 'up'
    },
    { 
      label: 'New Messages', 
      value: '42', 
      change: '+5%', 
      icon: HiOutlineChatBubbleLeftRight, 
      color: 'bg-purple-50 text-purple-600',
      trend: 'up'
    },
    { 
      label: 'Course Enrollments', 
      value: '856', 
      change: '+18%', 
      icon: HiOutlineBookOpen, 
      color: 'bg-emerald-50 text-emerald-600',
      trend: 'up'
    },
    { 
      label: 'Active Alerts', 
      value: '12', 
      change: '-2%', 
      icon: HiOutlineBell, 
      color: 'bg-orange-50 text-orange-600',
      trend: 'down'
    },
  ];

  return (
    <div className="space-y-8 animate-in fade-in duration-500">
      {/* Header Greeting Section */}
      <header className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 to-violet-700 p-8 text-white shadow-xl shadow-indigo-100">
        <div className="relative z-10">
          <h1 className="text-3xl font-bold md:text-4xl">
            {greeting}, {user?.first_name || 'Admin'}! 👋
          </h1>
          <p className="mt-2 text-indigo-100 text-lg max-w-xl">
            Welcome back to your dashboard. Here's what's happening with your platform today.
          </p>
        </div>
        
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 -mr-16 -mt-16 h-64 w-64 rounded-full bg-white/10 blur-3xl"></div>
        <div className="absolute bottom-0 left-0 -ml-16 -mb-16 h-64 w-64 rounded-full bg-indigo-400/20 blur-3xl"></div>
      </header>

      {/* System Overview Section */}
      <section>
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-bold text-gray-800 flex items-center gap-2">
            System Overview 
            <span className="text-sm font-normal text-gray-500 bg-gray-100 px-2 py-0.5 rounded-full">Live Updates</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div 
              key={index}
              className="group p-6 bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-all hover:-translate-y-1"
            >
              <div className="flex items-start justify-between">
                <div className={`p-3 rounded-xl ${stat.color}`}>
                  <stat.icon className="w-6 h-6" />
                </div>
                <div className={`flex items-center gap-1 text-sm font-medium ${stat.trend === 'up' ? 'text-emerald-600' : 'text-rose-600'}`}>
                  {stat.change}
                  <HiOutlineArrowTrendingUp className={`w-4 h-4 ${stat.trend === 'down' && 'rotate-180'}`} />
                </div>
              </div>
              <div className="mt-4">
                <h3 className="text-gray-500 font-medium text-sm">{stat.label}</h3>
                <p className="text-2xl font-bold text-gray-900 mt-1">{stat.value}</p>
              </div>
              <div className="mt-4 h-1 w-full bg-gray-50 rounded-full overflow-hidden">
                <div 
                  className={`h-full rounded-full transition-all duration-1000 delay-300 ${stat.color.split(' ')[1].replace('text-', 'bg-')}`} 
                  style={{ width: '65%' }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Dashboard;